// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__KpAGL","loaderOuter":"PageOverlayLoader_loaderOuter__3xGJC"};